import { MoreVertical, Edit, Trash2 } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { cn } from '@/lib/utils'

interface MessageContextMenuProps {
  messageId: string
  onEdit: () => void
  onDelete: () => void
  className?: string
  canEdit?: boolean // Se false, desabilita a opção de editar
}

export function MessageContextMenu({
  messageId,
  onEdit,
  onDelete,
  className,
  canEdit = true
}: MessageContextMenuProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className={cn(
            // Mobile: sempre visivel e com area de toque maior (nao existe hover
            // no touch — antes o mestre nao conseguia editar/excluir pelo celular).
            // Desktop (md:): comportamento original, aparece no hover da bolha.
            "h-8 w-8 opacity-100 md:h-6 md:w-6 md:opacity-0 md:group-hover:opacity-100 transition-opacity",
            "text-game-secondary hover:text-game-primary hover:bg-game-hover",
            className
          )}
          onClick={(e) => e.stopPropagation()}
        >
          <MoreVertical className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="bg-game-secondary border-game-primary">
        {canEdit && (
          <DropdownMenuItem
            onClick={(e) => {
              e.stopPropagation()
              onEdit()
            }}
            className="text-game-primary hover:bg-game-hover cursor-pointer"
          >
            <Edit className="h-4 w-4 mr-2" />
            Editar
          </DropdownMenuItem>
        )}
        <DropdownMenuItem
          onClick={(e) => {
            e.stopPropagation()
            onDelete()
          }}
          className="text-red-400 hover:bg-red-900/20 cursor-pointer"
        >
          <Trash2 className="h-4 w-4 mr-2" />
          Excluir
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
